module.exports = __webpack_public_path__ + "img/3_54.62c387e2.png";